/**
 * Empty search landing: URL params (?scenario= & ?term=), hero copy, panel visibility, analytics.
 */
(function () {
  'use strict';

  function getParams() {
    var q = window.location.search || '';
    var params = new URLSearchParams(q);
    return {
      scenario: (params.get('scenario') || '').trim(),
      term: (params.get('term') || '').trim(),
    };
  }

  function substituteTerm(str, term) {
    if (!str || typeof str !== 'string') return str || '';
    return str.split('{term}').join(term || '');
  }

  function escapeHtml(value) {
    var entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return entities[character];
    });
  }

  function analyticsAllowed() {
    try {
      var shopify = window.Shopify;
      var privacy = shopify && shopify.customerPrivacy;
      return !!(shopify && shopify.theme && shopify.theme.role === 'main' &&
        privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true);
    } catch (e) {
      return false;
    }
  }

  function safeAnalyticsTerm(value) {
    try {
      var analytics = window.FHDiscoveryAnalytics;
      if (!analytics || typeof analytics.safeTerm !== 'function') return '';
      return analytics.safeTerm(value);
    } catch (e) {
      return '';
    }
  }

  // Keep only same-origin paths whose decoded segments pass the shared sanitizer.
  // Query strings, fragments and unsafe paths never reach analytics or handles.
  function analyticsPath(url) {
    try {
      if (!window.FHDiscoveryAnalytics ||
        typeof window.FHDiscoveryAnalytics.safeTerm !== 'function') return '';
      var parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin || !/^https?:$/.test(parsed.protocol)) return '';
      var segments = parsed.pathname.split('/').map(function (segment) {
        return decodeURIComponent(segment).toLowerCase();
      });
      if (segments.some(function (segment) {
        return segment && (!/^[a-z0-9][a-z0-9_-]*$/.test(segment) ||
          safeAnalyticsTerm(segment) !== segment);
      })) return '';
      return segments.join('/');
    } catch (e) {
      return '';
    }
  }

  function pushDataLayer(payload) {
    if (!analyticsAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function fireView(scenario, term) {
    var linkUrl = analyticsPath(window.location.href);
    var payload = {
      event: 'empty_search_landing_view',
      empty_search_scenario: scenario || '',
      empty_search_term: safeAnalyticsTerm(term),
      link_url: linkUrl,
    };
    pushDataLayer(payload);
  }

  function fireClick(data) {
    var payload = Object.assign({ event: 'empty_search_landing_click' }, data);
    pushDataLayer(payload);
  }

  function parsePathHandles(url) {
    try {
      var u = new URL(url, window.location.origin);
      var path = u.pathname || '';
      var parts = path.split('/').filter(Boolean);
      var out = {};
      var ci = parts.indexOf('collections');
      if (ci >= 0 && parts[ci + 1]) out.collection_handle = parts[ci + 1];
      var pi = parts.indexOf('products');
      if (pi >= 0 && parts[pi + 1]) out.product_handle = parts[pi + 1];
      return out;
    } catch (e) {
      return {};
    }
  }

  function bindClickTracking(scenario, term) {
    var selectors = [
      { sel: '.section-empty-search-hero', type: 'hero' },
      { sel: '.empty-search-collection-list-wrapper', type: 'collection_list' },
      { sel: '.empty-search-featured-wrapper', type: 'featured' },
    ];
    selectors.forEach(function (item) {
      var root = document.querySelector(item.sel);
      if (!root) return;
      root.addEventListener(
        'click',
        function (e) {
          var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
          if (!a || !root.contains(a)) return;
          var href = a.getAttribute('href') || '';
          var text = a.textContent || '';
          // A URL label can contain encoded query data that safeTerm cannot redact.
          if (/(?:https?:\/\/|www\.|(?:^|\s)\/\S)/i.test(text)) text = '';
          text = safeAnalyticsTerm(text);
          var linkUrl = analyticsPath(href);
          var handles = linkUrl ? parsePathHandles(linkUrl) : {};
          fireClick({
            scenario: scenario || '',
            term: safeAnalyticsTerm(term),
            link_type: item.type,
            link_url: linkUrl,
            link_text: text,
            collection_handle: handles.collection_handle || '',
            product_handle: handles.product_handle || '',
          });
        },
        true
      );
    });
  }

  function resolveScenarioKey(data, scenarioParam) {
    var scenarios = data.scenarios || {};
    if (scenarioParam && Object.prototype.hasOwnProperty.call(scenarios, scenarioParam)) {
      return scenarioParam;
    }
    if (
      data.default_scenario_key &&
      Object.prototype.hasOwnProperty.call(scenarios, data.default_scenario_key)
    ) {
      return data.default_scenario_key;
    }
    var keys = Object.keys(scenarios);
    return keys.length ? keys[0] : '';
  }

  function applyPanels(resolvedKey) {
    var panels = document.querySelectorAll('[data-empty-scenario]');
    panels.forEach(function (el) {
      var sk = el.getAttribute('data-empty-scenario') || '';
      el.classList.toggle('is-active', sk === resolvedKey);
    });
  }

  function applyHero(data, scenarioParam, term) {
    var titleEl = document.getElementById('empty-search-hero-title');
    var bodyEl = document.getElementById('empty-search-hero-body');
    if (!titleEl || !bodyEl) return;

    var scenarios = data.scenarios || {};
    var key = resolveScenarioKey(data, scenarioParam);
    var block = key ? scenarios[key] || {} : {};

    var title = block.hero_title != null ? String(block.hero_title) : '';
    var body = block.hero_body != null ? String(block.hero_body) : '';

    if (!title && data.defaults && data.defaults.hero_title) {
      title = String(data.defaults.hero_title);
    }
    if (!body && data.defaults && data.defaults.hero_body) {
      body = String(data.defaults.hero_body);
    }

    title = substituteTerm(title, term);
    body = substituteTerm(body, escapeHtml(term));

    titleEl.textContent = title;
    bodyEl.innerHTML = body;
  }

  function init() {
    var dataEl = document.getElementById('empty-search-landing-data');
    if (!dataEl) return;

    var data = {};
    try {
      data = JSON.parse(dataEl.textContent || '{}');
    } catch (e) {
      data = {};
    }

    var params = getParams();
    var scenario = params.scenario;
    var term = params.term;

    document.documentElement.dataset.emptyScenario = scenario;
    document.documentElement.dataset.emptyTerm = term;

    // If scenario is missing, treat term as the scenario key (common redirect form: ?term=disney)
    var scenarioCandidate = scenario || (term || '').toLowerCase();
    var resolvedKey = resolveScenarioKey(data, scenarioCandidate);

    window.EmptySearchLanding = {
      scenario: scenario,
      term: term,
      resolvedScenarioKey: resolvedKey,
      data: data,
    };

    applyHero(data, scenarioCandidate, term);
    applyPanels(resolvedKey);

    fireView(resolvedKey, term);
    bindClickTracking(resolvedKey, term);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
